exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.peppol-interpreter__detail[data-v-0cea6302] {\n\tmargin: 8px 0 0;\n\tfont-size: 12px;\n\tline-height: 1.4;\n\topacity: 0.9;\n}\n", ""]);

// exports
